<template>
  <el-dialog title="结业设置" :visible.sync="dialogInfo.flag" :close-on-click-modal="false" width="500px">
    <el-form :model="ruleForm" ref="ruleForm" :rules="rules" label-width="100px" class="form" size="small">
      <el-form-item label="结业状态：" prop="graduationStatus">
        <el-select v-model="ruleForm.graduationStatus" placeholder="请选择结业状态" @change="graduationStatusChange">
          <el-option v-for="(item, i) in graduationStatusData" :key="i" :label="item.paramValue"
            :value="item.paramKey"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="培训天数：" prop="trainDays">
        <el-input-number v-model="ruleForm.trainDays" :precision="2" :min="0"></el-input-number>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close(false)" size="small">取消</el-button>
      <el-button type="primary" size="small" @click="confirm">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { liaisonTrainDays, graduationLiaisons } from "@/api/groupManage.js";
import { validatorTrainDays } from "@/utils/rules/validators.js";
export default {
  props: {
    dialogInfo: {
      type: Object,
      default: () => {
        return {
          flag: false,
        };
      },
    },
    graduationStatusData: {
      tyep: Array,
      default: [],
    },
  },
  data() {

    return {
      ruleForm: {
        graduationStatus: '0',
        trainDays: 0,
      },
      rules: {
        graduationStatus: [
          { required: true, message: "请选择结业状态", trigger: "blur" },
        ],
        trainDays: null,
      },
      classTrainDays: 0,
    };
  },
  created() {
    this.ruleForm = {
      graduationStatus: this.dialogInfo.graduationStatus || '0',
      trainDays: this.dialogInfo.trainDays || 0,
    }
    this.changeRulesByStatus();
    this.getClassTrainDays();
  },
  methods: {
    getClassTrainDays() {
      liaisonTrainDays({
        uuid: this.dialogInfo.uuid
      }).then(({ code, data }) => {
        if (code == 0) {
          this.classTrainDays = data.trainDays
        }
      });
    },
    graduationStatusChange() {
      if (this.ruleForm.graduationStatus === '1') {
        this.ruleForm.trainDays = this.classTrainDays;
      } else {
        this.ruleForm.trainDays = 0;
      }
      this.changeRulesByStatus();
    },
    changeRulesByStatus() {
      if (this.ruleForm.graduationStatus === '1') {
        this.rules.trainDays = [
          { required: true, validator: validatorTrainDays, trigger: ["blur", "change"] },
        ];
      } else {
       this.rules.trainDays = null;
      }
    },
    confirm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          graduationLiaisons({
            ...this.ruleForm,
            uuidList: [this.dialogInfo.uuid],
          }).then(({ code }) => {
            if (code !== 0) return;
            this.$emit("close", true);
          });
        }
      });
    },
    close(flag) {
      this.$emit("close", flag);
    },
  },
};
</script>

<style></style>